import { useState } from 'react';

export default function useClientDataState({
    client,
    termsAndPrivacy,
    generalData,
}) {
    const createCountriesLocalizationsData = (data) => {
        return data?.reduce((acc, el) => {
            acc[el.country_code] = el;
            return acc;
        }, {});
    };

    const countriesLocalizationsData = createCountriesLocalizationsData(
        client?.countries_localizations,
    );

    const privacyData = createCountriesLocalizationsData(
        termsAndPrivacy?.policy,
    );
    const [data, setData] = useState({
        ...client,
        name: client?.name,
        client_uid: client?.client_uid,
        api_url: client?.api_url,
        crm_url: client?.crm_url,
        api_key: client?.api_key,
        api_secret: client?.api_secret,
        countries_localizations: {
            sv: {
                ...countriesLocalizationsData.sv,
                company_name:
                    countriesLocalizationsData?.sv?.company_name || '',
                service_name:
                    countriesLocalizationsData?.sv?.service_name || '',
                title_service_name:
                    countriesLocalizationsData?.sv?.title_service_name ||
                    countriesLocalizationsData?.sv?.service_name ||
                    '',
                company_full_name:
                    countriesLocalizationsData?.sv?.company_full_name || '',
                privacy_policy: privacyData.sv?.privacy_policy || null,
                terms_of_use: privacyData.sv?.terms_of_use || null,
            },
            no: {
                ...countriesLocalizationsData.no,
                company_name:
                    countriesLocalizationsData?.no?.company_name || '',
                service_name:
                    countriesLocalizationsData?.no?.service_name || '',
                title_service_name:
                    countriesLocalizationsData?.no?.title_service_name ||
                    countriesLocalizationsData?.no?.service_name ||
                    '',
                company_full_name:
                    countriesLocalizationsData?.no?.company_full_name || '',
                privacy_policy: privacyData?.no?.privacy_policy || null,
                terms_of_use: privacyData?.no?.terms_of_use || null,
            },
            fi: {
                ...countriesLocalizationsData?.fi,
                company_name:
                    countriesLocalizationsData?.fi?.company_name || '',
                service_name:
                    countriesLocalizationsData?.fi?.service_name || '',
                title_service_name:
                    countriesLocalizationsData?.fi?.title_service_name ||
                    countriesLocalizationsData?.fi?.service_name ||
                    '',
                company_full_name:
                    countriesLocalizationsData?.fi?.company_full_name || '',
                privacy_policy: privacyData?.fi?.privacy_policy || null,
                terms_of_use: privacyData?.fi?.terms_of_use || null,
            },
            da: {
                ...countriesLocalizationsData?.da,
                company_name:
                    countriesLocalizationsData?.da?.company_name || '',
                service_name:
                    countriesLocalizationsData?.da?.service_name || '',
                title_service_name:
                    countriesLocalizationsData?.da?.title_service_name ||
                    countriesLocalizationsData?.da?.service_name ||
                    '',
                company_full_name:
                    countriesLocalizationsData?.da?.company_full_name || '',
                privacy_policy: privacyData?.da?.privacy_policy || null,
                terms_of_use: privacyData?.da?.terms_of_use || null,
            },
            en: {
                ...countriesLocalizationsData?.en,
                company_name:
                    countriesLocalizationsData?.en?.company_name || '',
                service_name:
                    countriesLocalizationsData?.en?.service_name || '',
                title_service_name:
                    countriesLocalizationsData?.en?.title_service_name ||
                    countriesLocalizationsData?.en?.service_name ||
                    '',
                company_full_name:
                    countriesLocalizationsData?.en?.company_full_name || '',
                privacy_policy: privacyData.en?.privacy_policy || null,
                terms_of_use: privacyData?.en?.terms_of_use || null,
            },
            is: {
                ...countriesLocalizationsData?.is,
                company_name:
                    countriesLocalizationsData?.is?.company_name || '',
                service_name:
                    countriesLocalizationsData?.is?.service_name || '',
                title_service_name:
                    countriesLocalizationsData?.is?.title_service_name ||
                    countriesLocalizationsData?.is?.service_name ||
                    '',
                company_full_name:
                    countriesLocalizationsData?.is?.company_full_name || '',
                privacy_policy: privacyData.is?.privacy_policy || null,
                terms_of_use: privacyData?.is?.terms_of_use || null,
            },
        },
        // database_name: client?.database_name,
        // database_host: client?.database_host,
        // database_user_name: client?.database_user_name,
        // database_password: client?.database_password,
        is_send_sms_if_phone_not_confirmed:
            client?.is_send_sms_if_phone_not_confirmed,
        theme_id: client?.theme?.id,
        criipto_methods: generalData?.criipto_methods,
        white_label_colors: {
            graphic_colors: {
                light:
                    generalData?.white_label_colors?.graphic_colors?.light ||
                    '',
                default:
                    generalData?.white_label_colors?.graphic_colors?.default ||
                    '',
                dark:
                    generalData?.white_label_colors?.graphic_colors?.dark || '',
            },
            primary_button: {
                default:
                    generalData?.white_label_colors?.primary_button?.default ||
                    '',
                hover:
                    generalData?.white_label_colors?.primary_button?.hover ||
                    '',
                active:
                    generalData?.white_label_colors?.primary_button?.active ||
                    '',
                outlined:
                    generalData?.white_label_colors?.primary_button?.outlined ||
                    false,
            },
            primary_button_content: {
                default:
                    generalData?.white_label_colors?.primary_button_content
                        ?.default || '',
                hover:
                    generalData?.white_label_colors?.primary_button_content
                        ?.hover || '',
                active:
                    generalData?.white_label_colors?.primary_button_content
                        ?.active || '',
            },
            secondary_button: {
                default:
                    generalData?.white_label_colors?.secondary_button
                        ?.default || '',
                hover:
                    generalData?.white_label_colors?.secondary_button?.hover ||
                    '',
                active:
                    generalData?.white_label_colors?.secondary_button?.active ||
                    '',
                outlined:
                    generalData?.white_label_colors?.secondary_button
                        ?.outlined || false,
            },
            secondary_button_content: {
                default:
                    generalData?.white_label_colors?.secondary_button_content
                        ?.default || '',
                hover:
                    generalData?.white_label_colors?.secondary_button_content
                        ?.hover || '',
                active:
                    generalData?.white_label_colors?.secondary_button_content
                        ?.active || '',
            },
            links: {
                default: generalData?.white_label_colors?.links?.default || '',
                hover: generalData?.white_label_colors?.links?.hover || '',
                active: generalData?.white_label_colors?.links?.active || '',
                underlined:
                    generalData?.white_label_colors?.links?.underlined || false,
            },
            icons: {
                hover: generalData?.white_label_colors?.icons?.hover || '',
            },
            selectors: {
                active:
                    generalData?.white_label_colors?.selectors?.active || '',
            },
            email_button: {
                default:
                    generalData?.white_label_colors?.email_button?.default ||
                    '',
                hover:
                    generalData?.white_label_colors?.email_button?.hover || '',
                active:
                    generalData?.white_label_colors?.email_button?.active || '',
                outlined:
                    generalData?.white_label_colors?.email_button?.outlined ||
                    false,
            },
            email_button_content: {
                default:
                    generalData?.white_label_colors?.email_button_content
                        ?.default || '',
                hover:
                    generalData?.white_label_colors?.email_button_content
                        ?.hover || '',
                active:
                    generalData?.white_label_colors?.email_button_content
                        ?.active || '',
            },
        },
    });

    return [data, setData];
}
